import styles from '../styles/Sniwwoc.module.css';
import GoBackSection from "../components/GoBackSection";

// Data
import { designs } from "../data/graphicDesigns";

// Components
import Sliders from '../components/Sliders/Sliders';

export default function Sniwwoc() {

  return (
    <>
      <GoBackSection section="designs"/>
      <div className={styles.designContainer}>
        <p className={styles.title}>SNIWWOC Product Desings</p>
        <p style={{marginBottom: "30px", textAlign: "center"}}>
          <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Tools used</span>
          Illustrator, Photoshop & Figma
        </p>
        <Sliders designs={designs} />
      </div>
    </>
  )
}